<div class="container">
  <div class="mt-4 mb-5 d-flex justify-content-center align-items-center flex-wrap flex-column">
    <div>
      <h1>404</h1>
    </div>
    <h2>{{'notFound.title' | translate}}</h2>
 
  </div>
</div>